






import { Component, Vue, Prop } from 'vue-property-decorator';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
import 'overlayscrollbars/css/OverlayScrollbars.css';

@Component({
  components: {
    OverlayScrollbarsComponent,
  },
})
export default class ScrollbarWrapper extends Vue {
  @Prop({ type: Boolean, default: true }) scrollX !: boolean;

  options = {
    scrollbars: {
      autoHide: 'leave',
      clickScrolling: true,
    },
    overflowBehavior: {
      x: this.scrollX ? 'scroll' : 'hidden',
      y: 'scroll',
    },
  }
}
